export default __webpack_public_path__ + "static/media/kontena.92132a66.svg";